var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{attrs:{"small":"","label":"","outline":"","color":_vm.statusMap[_vm.status].color}},[_c('strong',[_vm._v(_vm._s(_vm.statusMap[_vm.status].label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }